import { Button, Icon } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getChannel } from 'utils/getChannel';

export type CompletionStageProps = { onDone(): void };

/**
 * Fills the completion badge behind the check icon. The 32px circle,
 * spacing and shape stay on `.wellbeing-measure-modal__completion-icon` in
 * the shared modal Sass — this only supplies the one colour it has no token
 * for.
 */
const CompletionIcon = styled.span`
  background: ${({ theme }) => theme.colors.background.secondary};
`;

const CompletionStage = ({ onDone }: CompletionStageProps) => {
  const { t: translate } = useTranslation('homepage');
  const { productName } = getChannel();

  return (
    <div className="wellbeing-measure-modal__completion">
      <CompletionIcon
        className="wellbeing-measure-modal__completion-icon"
        aria-hidden="true"
      >
        <Icon icon="check" size="medium" />
      </CompletionIcon>
      {/* `Shared/Modal` hardcodes `aria-labelledby="modal-title"`, so this
          carries that id to give the completion dialog an accessible name. */}
      <h2 id="modal-title" className="title-m">
        {translate('wellbeing_measure.completion.title')}
      </h2>
      <p className="body-m">
        {translate('wellbeing_measure.completion.body', { productName })}
      </p>
      <Button
        variant="primary"
        size="medium"
        label={translate('wellbeing_measure.completion.done')}
        onClick={onDone}
      />
    </div>
  );
};

export default CompletionStage;
